import { render, staticRenderFns } from "./CInfoModal.vue?vue&type=template&id=48724fdf&scoped=true&"
import script from "./CInfoModal.vue?vue&type=script&lang=ts&"
export * from "./CInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CInfoModal.vue?vue&type=style&index=0&id=48724fdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48724fdf",
  null
  
)

export default component.exports